import React from 'react';
import MediaQuery from 'react-responsive';

import { AccountOnlineAnalysis, AccountSkinAnalysis } from '../MyLom/Account/EditAccount/Types';
import { SkinAnalysisSectionIdentifier } from '../Types';
import SkinAnalysisLinks from './Components/SkinAnalysisLinks';
import SkinAnalysisTable from './Components/SkinAnalysisTable';
import SkinAnalysisTableMobile from './Components/SkinAnalysisTableMobile';

import './SkinAnalysisSection.scss';

interface Props {
    skinAnalysisSectionIdentifier: SkinAnalysisSectionIdentifier;
    skinAnalyses: Array<AccountSkinAnalysis | AccountOnlineAnalysis>;
    showLinks: boolean;
    useReactRouterLink: boolean;

    // for filter
    toggleVisibility?: () => void;
    label?: string;
}

const SkinAnalysisSection: React.FunctionComponent<Props> = (props) => {
    if (!props.skinAnalyses || props.skinAnalyses.length === 0) {
        return null;
    }

    return (
        <section className="skin-analysis__section">
            {props.label ? <h4 className="skin-analysis__user-name">{props.label}</h4> : null}
            <MediaQuery minWidth={915}>
                {(matches: boolean) =>
                    matches ? (
                        <SkinAnalysisTable
                            skinAnalysisSectionIdentifier={props.skinAnalysisSectionIdentifier}
                            skinAnalyses={props.skinAnalyses}
                            useReactRouterLink={props.useReactRouterLink}
                            toggleVisibility={props.toggleVisibility}
                        />
                    ) : (
                        <MediaQuery minWidth={515}>
                            {(doNotSaveSpace: boolean) => (
                                <SkinAnalysisTableMobile
                                    skinAnalysisSectionIdentifier={props.skinAnalysisSectionIdentifier}
                                    skinAnalyses={props.skinAnalyses}
                                    useReactRouterLink={props.useReactRouterLink}
                                    toggleVisibility={props.toggleVisibility}
                                />
                            )}
                        </MediaQuery>
                    )
                }
            </MediaQuery>
            {props.showLinks && props.toggleVisibility ? (
                <SkinAnalysisLinks toggleVisibility={props.toggleVisibility} />
            ) : null}
        </section>
    );
};

export default SkinAnalysisSection;
